var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { useConfigContext } from '@m4b-design/config-provider';
import { Spin } from '@arco-design/web-react';
import cx from 'classnames';
import { Tip } from './tip';
import { LoadingIcon } from './svg';
import './style/loading.less';
import { useColor } from './utils';
var sizeMap = {
    large: 26,
    L: 26,
    default: 18,
    M: 18,
    small: 12,
    S: 12,
};
var LoadingRender = function (props, ref) {
    var _a;
    var _b = props.color, color = _b === void 0 ? 'black' : _b, _c = props.size, _size = _c === void 0 ? 'medium' : _c, className = props.className, _tip = props.tip, dot = props.dot, restProps = __rest(props, ["color", "size", "className", "tip", "dot"]);
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-loading");
    var colorConfig = useColor(color);
    var size = typeof _size === 'number' ? _size : (_a = sizeMap[_size]) !== null && _a !== void 0 ? _a : sizeMap.small;
    var tip = _tip === undefined ? undefined : (React.createElement(Tip, { tip: _tip, colorConfig: colorConfig, prefixCls: prefixCls }));
    return (React.createElement(Spin, __assign({ "data-tid": "m4b_loading", icon: dot ? undefined : React.createElement(LoadingIcon, { prefixCls: prefixCls, colorConfig: colorConfig }), ref: ref, className: cx(prefixCls, className), size: size, dot: dot, tip: tip }, restProps)));
};
var Loading = forwardRef(LoadingRender);
Loading.displayName = 'Loading';
export default Loading;
